import counterpart from "counterpart";

export function getCardSearchFilterList(searchText, parsedPermission) {
  let query;
  let optionforAcquirerUser = [{
    id: '0',
    searchText,
    query: counterpart('globalTranslate.globalSearch.searchFor'),
    searchType: 'Search for...',
    isEmpty: true,
  },
  {
    id: '1',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inCaseNumber'),
    searchType: 'caseNumber',
    isEmpty: false,
  },
  {
    id: '2',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inMerchantNumber'),
    searchType: 'merchantNumber',
    isEmpty: false,
  }];
  
  let optionWithAccountNumber = [{
    id: '0',
    searchText,
    query: counterpart('globalTranslate.globalSearch.searchFor'),
    searchType: 'Search for...',
    isEmpty: true,
  },
  {
    id: '1',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inCaseNumber'),
    searchType: 'caseNumber',
    isEmpty: false,
  },
  {
    id: '2',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inMerchantNumber'),
    searchType: 'merchantNumber',
    isEmpty: false,
  },
  {
    id: '3',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inAccountNumber'),
    searchType: 'accountNumber',
    isEmpty: false,
  },
  {
    id: '4',
    searchText,
    query: ' in ARN',
    searchType: 'arn',
    isEmpty: false,
  },
  ];
  
  let optionWithoutAccountNumber = [{
    id: '0',
    searchText,
    query: counterpart('globalTranslate.globalSearch.searchFor'),
    searchType: 'Search for...',
    isEmpty: true,
  },
  {
    id: '1',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inCaseNumber'),
    searchType: 'caseNumber',
    isEmpty: false,
  },
  {
    id: '2',
    searchText,
    query: counterpart('globalTranslate.globalSearch.inMerchantNumber'),
    searchType: 'merchantNumber',
    isEmpty: false,
  },

  {
    id: '3',
    searchText,
    query: ' in ARN',
    searchType: 'arn',
    isEmpty: false,
  },
  ];
  let role= JSON.parse(sessionStorage.getItem('state')).auth.user.role.key;
  let acquirerUsers=['DiMS_ACQUIRER_ADMIN','DiMS_ACQUIRER_USER'];
  let isAcquirerUser=false
  if(acquirerUsers.findIndex(acquirer=>acquirer==role)!=-1){
      isAcquirerUser=true
  }
  let canViewFullNumber = parsedPermission.accountNumber.canViewFullNumber;
  return isAcquirerUser ? optionforAcquirerUser : canViewFullNumber ? optionWithAccountNumber :optionWithoutAccountNumber;
}
